import {DropdownItemLink, type DropdownItemType, Pressable} from "@hosttools/frontend";
import type React from "react";
import {memo, useCallback} from "react";

type Props = {
    menu: DropdownItemType;
    onClickMenu: (menu: DropdownItemType) => void;
};

const MenuItem: React.FC<Props> = ({menu, onClickMenu}) => {
    const handleClick = useCallback(() => {
        onClickMenu(menu);
    }, [onClickMenu, menu]);

    return (
        <Pressable key={menu.label} className="py-2" onPress={handleClick}>
            <DropdownItemLink size="sm" {...menu} />
        </Pressable>
    );
};

export default memo(MenuItem);
